export const QA_NAME_CALENDAR_SETTINGS = 'calendarSettings'

export const QA_NAME_CALENDAR_SETTINGS_TASK_TYPES = 'calendarSettingsTaskTypes'

export const QA_NAME_CALENDAR_SETTINGS_DUE_DATES = 'calendarSettingsDueDates'

export const QA_NAME_CALENDAR_SETTINGS_TASK_TYPES_SEARCH =
  'calendarSettingsTaskTypesSearch'

export const QA_NAME_CALENDAR_SETTINGS_TASK_TYPES_SETTINGS_LINK =
  'calendarSettingsTaskTypesSettingsLink'

export const CALENDAR_SETTINGS_TASK_TYPES_SECTION_TITLE_KEY =
  'CalendarSettings.TaskTypesSectionTitleKey'

export const CALENDAR_SETTINGS_TASK_TYPES_SECTION_DESCRIPTION_KEY =
  'CalendarSettings.TaskTypesSectionDescriptionKey'

export const CALENDAR_SETTINGS_FIELD_NAME_TASK_TYPES = 'task_types'

export const CALENDAR_SETTINGS_FIELD_NAME_SHOW_PROVIDER_TASKS =
  'show_provider_tasks'

export const CALENDAR_SETTINGS_FIELD_NAME_DAILY_LIMIT = 'daily_followup_limit'

export const CALENDAR_SETTINGS_DAILY_LIMIT_MIN = 1

export const CALENDAR_SETTINGS_DAILY_LIMIT_MAX = 99

export const CALENDAR_SETTINGS_TASK_TYPES_SEARCH_THRESHOLD = 25

export const CALENDAR_SETTINGS_SWITCH_LABEL_KEYS = {
  off: 'CalendarSettings.SwitchOffLabelKey',
  on: 'CalendarSettings.SwitchOnLabelKey',
}

export const QA_NAME_CALENDAR_SETTINGS_LOAD_ERROR = 'calendarSettingsLoadError'

export const QA_NAME_CALENDAR_SETTINGS_NO_TIMEZONE =
  'calendarSettingsNoTimezone'

export const QA_NAME_CALENDAR_SETTINGS_TASK_TYPES_EMPTY =
  'calendarSettingsTaskTypesEmpty'

export const QA_NAME_CALENDAR_SETTINGS_TASK_TYPES_NOT_FOUND =
  'calendarSettingsTaskTypesNotFound'
